import * as React from 'react'

export const DEFAULT_ALIGN = 'left' as const
export type DropdownAlignment = 'left' | 'center' | 'right'
